export default class BotView
{
    constructor(_options)
    {
        this.bot = _options.bot
        this.factory = _options.factory
        this.container = this.factory.createCoalBot()
        this.lastCarrying = -1
        this.phase = 0
        this.syncCargo()
    }

    syncCargo()
    {
        if(this.lastCarrying === this.bot.carrying)
            return
        this.lastCarrying = this.bot.carrying
        const cargo = this.container.userData.cargo
        for(const child of [...cargo.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            cargo.remove(child)
        }
        for(let index = 0; index < this.bot.carrying; index++)
        {
            const item = this.factory.createItem('coal', 0.72)
            item.position.set((index % 2 - 0.5) * 0.28, 0, Math.floor(index / 2) * 0.2)
            cargo.add(item)
        }
    }

    update(_delta)
    {
        this.container.position.set(this.bot.x, this.bot.y, 0)
        this.phase += _delta * (this.bot.moving ? 9 : 3)
        const parts = this.container.userData
        parts.body.position.z = this.bot.moving ? Math.abs(Math.sin(this.phase)) * 0.05 : 0
        parts.antenna.rotation.z = Math.sin(this.phase * 0.6) * 0.12
        if(this.bot.moving && this.bot.path[0])
        {
            const target = this.bot.path[0]
            this.container.rotation.z = Math.atan2(- (target.x - this.bot.x), target.y - this.bot.y)
            for(const wheel of parts.wheels)
                wheel.rotation.x += _delta * 8
        }
        this.syncCargo()
    }
}
